module.exports = __webpack_public_path__ + "img/link_pg.5d03c5fa.png";